import $ from 'jquery';

$.addInit(function(context) {
	var base = '.b-accordion';
	$(base, context).each(function(){
		var component = $(this);
		var header = component.find(base + '-header');
		var content = component.find(base + '-content');

		header.on('click', function(e) {
			if (!$(e.target).closest('.b-filterTooltip').length) {
				component.toggleClass('m-active');
			}
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-accordion.js
// module id = 30
// module chunks = 0